import { useLocation } from "react-router-dom";
import { ArrowUpRight, Sparkles, Camera } from "lucide-react";
import { useLang } from "@/lib/i18n";

export const COACH_URL = "https://coiffure-suivi.preview.emergentagent.com";
const ext = { href: COACH_URL, target: "_blank", rel: "noopener noreferrer" };

export function CoachFloatingButton() {
  const { pathname } = useLocation();
  const { t, lang } = useLang();
  const lift = pathname.startsWith("/produit/") || pathname.startsWith("/en/product/") ? "bottom-24 lg:bottom-6" : "bottom-5 md:bottom-6";
  if (lang === "en") return null; // coach en français uniquement : pas de distraction pour les visiteuses anglophones
  return (
    <a
      {...ext}
      data-testid="coach-floating-button"
      aria-label={t("Mon Coach Cheveux gratuit")}
      className={`fixed right-4 z-[45] hidden items-center gap-2 rounded-full bg-[#99694A] px-5 py-3 text-sm font-semibold text-white shadow-[0_12px_32px_-8px_rgba(0,0,0,0.6)] transition-[transform,background-color] duration-300 hover:-translate-y-0.5 hover:bg-[#87593c] md:right-6 md:flex ${lift}`}
    >
      <Sparkles className="h-4 w-4 shrink-0" />
      <span>{t("Mon Coach Cheveux gratuit")}</span>
    </a>
  );
}

export function CoachProductBox() {
  return (
    <a {...ext} data-testid="product-coach-box" className="group mt-6 flex items-center gap-4 rounded-xl border border-[#99694A]/60 bg-[#99694A]/12 px-4 py-4 transition-colors hover:bg-[#99694A]/25">
      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#99694A] text-white"><Camera className="h-4 w-4" /></span>
      <span className="flex-1 text-sm leading-snug text-[var(--parchment)]">Suivez vos résultats avec ce produit dans <strong className="text-[var(--gold-soft)]">Mon Coach Cheveux</strong></span>
      <ArrowUpRight className="h-4 w-4 shrink-0 text-[var(--gold-soft)] transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
    </a>
  );
}
